import React, {useEffect, useRef, useState} from "react";
import styles from './flyersCatalog.module.scss'
import {OrangeButton} from "../../../com/pagesTab/orangeBtn/OrangeButton";
import {ReactComponent as DeleteIcon} from "../../../../assets/editors/delete_icon.svg";
import {ReactComponent as ArchiveIcon} from "../../../../assets/editors/archive_icon.svg";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {FlyerClassDto, FlyerDto, SelectPageForTabsDto, UserDto} from "../../../../dtos";
import {history} from "../../../../helpers/history";
import {
    getFlippingFlyer,
} from "../../../../store";
import {getFlyers} from "../../../../store";
import {ActionType} from "../../../../store/actionTypes";
import {Flyer} from "./flyer/flyer";
import {PageSpinner} from "../../../com/pagesTab/pagesSpinner/spinner";
import envManager from "../../../../com/envManager/EnvManager";
import {
    archiveFlyer,
    clearFlyersData,
    hardDeleteFlyer,
    softDeleteFlyer
} from "../../../../store/actionCreators/flyersActionCreators";
import {
    dispatchEventDataType,
    EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE,
    EVENT_DATA_TYPE_CREAT_NEW_FLYER,
    addEventDataTypeListener,
    removeEventTypeListener,
    EVENT_DATA_TYPE_OPEN_PAGES_FLYER,
    EVENT_DATA_TYPE_DISABLE_TABS,
} from "../../../../globals/EventDispatcher";
import {setSelectedPageForTabs} from "../../../../store/actionCreators/pagesActionCreators";
import {CustomDataEvent} from "../../../../globals/CustomDataEvent";
import {Box, Button, CircularProgress, Grid, useMediaQuery} from "@mui/material";
import {makeStyles} from "@mui/styles";
import Select from "react-select";
import {OptionTypeBase} from "react-select/src/types";
import {
    toggleFlyerDetailsPopup,
    toggleFlyerRightPanel
} from "../../../../store/actionCreators/toggleActionForEditorActionCreators";
import {hideMenu} from "react-contextmenu/modules/actions";
import StatusPopup, {StatusPopupType} from "../../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../../pages/getSetttingsForPopup";
import {FlyerDetailsRightPanel} from "../../flyerDetailsPopup/flyerDetailsRightPanel";
import {
    FlippingFlyersCatalogCreateEditFlyer
} from "../../../flippingFlyersCatalog/flippingFlyersCatalogCreateEditFlyer";
import {WelcomeScreen} from "../../welcomeScreen/welcomeScreen";
import {resetFlyerState} from "../../../../store/actionCreators/flippingFlyerActionCreators";
import {getDate} from "../../../../globals/globFunctions";
import {
    changeFlyersClassFilter,
    changeFlyersViewFilter
} from "../../../../store/actionCreators/flyersFiltersActionCreators";

const customStyles = {
    control: (base: any, state: any) => ({
        ...base,
        border: "1px solid #ced4da",
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0,
        width: `120px`,
        cursor: "pointer",
        '&:hover': {
            // border: state.isFocused ? 0 : 0
            border: "1px solid #ced4da",
        }
    }),
}

const customStylesClassesView = {
    control: (base: any, state: any) => ({
        ...base,
        border: "1px solid #ced4da",
        // This line disable the blue border
        boxShadow: state.isFocused ? 0 : 0,
        width: `220px`,
        cursor: "pointer",
        '&:hover': {
            // border: state.isFocused ? 0 : 0
            border: "1px solid #ced4da",
        }
    }),
    menuList: (base: any, state: any) => ({
        ...base,
        maxHeight: `400px`
    })
}

const selectedOptions = [
    {
        value: `All`,
        label: `All`
    },
    {
        value: `In Edit`,
        label: `In Edit`
    },
    {
        value: `QA`,
        label: `QA`
    },
    {
        value: `Published`,
        label: `Published`
    },
    {
        value: `Expired`,
        label: `Expired`
    },
]

// const selectedOptions = ['All', 'In Edit', 'QA', 'Published'];
// const selectedOptions = ['All', 'In Edit', 'QA', 'Published', 'Inactive'];

export interface FlyersStateDto {
    archiveCount: number,
    softDeleteCount: number,
    showLoader: boolean,
    flyersData: FlyerDto[],
    activeFlyers: FlyerDto[],
    lastActivatedFlyer?: FlyerDto
    url: string,
    isSoftDelete?: boolean,
    isModalPopup?: boolean,
}

const useStyles = makeStyles(() => ({
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: "8px 12px",
        backgroundColor: "#FFFFFF",
        fontSize: "14px",
        // minHeight: "50px",
        alignItem: 'center',
        borderBottom: "1px solid #e4e4e4"

    },
    headerItem: {
        alignItems: 'center'
    },
    boxes: {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        width: '100%',
        // justifyContent: 'center',
        '&.leftControls': {
            justifyContent: 'flex-start',
            columnGap: "8px"
        },
        '&.rightControls': {
            justifyContent: 'flex-end',
            display: "flex",
            flexFlow: "row",
            columnGap: "24px",
            padding: "0 32px",
            '& > .MuiButton-root': {
                '&:hover': {
                    opacity: `0.5`
                }
            }
        }
    },
    urlBox: {
        fontWeight: "bold",
        margin: "5px",
        cursor: "pointer"
    },
    buttonLeftSide: {
        border: `none`,
        background: `inherit`,
        alignItems: `center`,
        position: `relative`,
        maxHeight: `20px`,
        padding: `0`,
    },
    counterWrapper: {
        border: `1.5px solid #616161`,
        position: `absolute`,
        bottom: `-7px`,
        right: `-12px`,
        width: `auto`,
        overflow: `hidden`,
        /* overflow-wrap: break-word; */
        textOverflow: `ellipsis`,
        // padding: `0 5px`,
        maxWidth: `50px`,
        minWidth: `25px`,
        borderRadius: `20px`,
        textAlign: `center`,
        fontSize: `10px`,
        lineHeight: `11px`,
        /* letter-spacing: 0.2em; */
        background: `white`,
        fontStyle: `normal`,
        fontWeight: `normal`,
        color: '#000000',
    },
    select: {
        height: `36px`,
        border: `1px solid #d1d7db`,
        boxSizing: `border-box`,
        borderRadius: `5px`,
        fontWeight: '700',
        margin: `0 5px`,
    },
    newFlyerBtnWrapper: {
        // marginRight: '20px'
        width: "auto"
    },
    contentWrapper: {
        height: "auto",
        maxHeight: "100%",
        // flex: "1 1 auto",
        overflow: "auto",
        // display: "flex",
        // flexFlow: "row",
        // flexWrap: "wrap",
        // columnGap: "2%",
        // rowGap: "2%",
        // margin: "5px 10px 0",
        padding: "0 12px 12px",
        marginTop: "0!important",
        // "&::-webkit-scrollbar": {
        //     width: "12px",
        // },
        //
        // "&::-webkit-scrollbar-track": {
        //     WebkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
        //     borderRadius: "10px",
        // },
        //
        // "&::-webkit-scrollbar-thumb": {
        //     borderRadius: "10px",
        //     WebkitBoxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.5)",
        // }
    }
}));


export const FlyersCatalog = () => {
    const dispatch = useDispatch();
    const isMd = useMediaQuery(`(max-width:1199px)`);
    const isXs = useMediaQuery(`(max-width:699px)`);
    const isSm = useMediaQuery(`(max-width:899px)`);
    const isMdForContent = useMediaQuery(`(max-width:1299px)`);
    const isLg = useMediaQuery(`(max-width:1635px)`);

    const flyerContentRef = useRef(null);
    const activeFlyersRef = useRef<FlyerDto[]>([]);

    const styleProps = {};
    const classes = useStyles(styleProps);
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isUserViewer = userDto.role !== 2 && userDto.role !== 3;
    const isAccountTier1 = userDto.accountTier === 1;

    const flyersState = useTypedSelector((state) => state.flyers);
    const flyerDetails = useTypedSelector((state) => state.flippingFlyer);
    const uploadImagesPopup = useTypedSelector((state) => state.uploadImagesPopup);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let filtersState = useTypedSelector((state) => state.flyersFiltersState);
    const flyerClasses = useTypedSelector(state => state.flyerClasses);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);

    let {isShowCreateNewFlyerPopup, isShowRightPanel} = useTypedSelector((state) => state.toggleActionsForFlyers);

    const [state, setState] = useState<FlyersStateDto>({
        archiveCount: 0,
        softDeleteCount: 0,
        flyersData: [],
        showLoader: true,
        activeFlyers: [],
        url: '',
    });

    const [isShouldCheckCurrentFlyerStateBeforeLeave, setIsShouldCheckCurrentFlyerStateBeforeLeave] = useState<boolean>(false);
    const [flyersForHold, setFlyersForHold] = useState<FlyerDto[]>([]);

    const [infoForPagesTab, setOpenPagesTab] = useState({
        isOpen: false,
        flyerCaption: ''
    });
    const [selectValue, setSelectValue] = useState<OptionTypeBase>(filtersState.viewFilter);

    const [selectClassesValue, setSelectClassesValue] = useState<OptionTypeBase>(filtersState.classFilter);

    const [isDisabledOptionBeforeFlyerWillBeReady, setDisabledStatus] = useState<boolean>(false);
    const [isShowModal, setShowModal] = useState<boolean>(false);
    const [actionIds, setActionIds] = useState<number[]>([]);
    const [showWelcomeScreen, setShowWelcomeScreen] = useState<boolean>(false);
    const [isShowLoader, setShowLoader] = useState<boolean>(false);
    const [flyerClassesState, setFlyerClassesState] = useState<any[]>([]);
    const rightPanelAnimationTimeInMs = 500;


    useEffect(() => {

        const flyerClassesData = flyerClasses?.flyerClasses?.map((flyerClass: FlyerClassDto) => {
            return {
                value: flyerClass.id,
                label: flyerClass.caption
            }
        });

        setFlyerClassesState([{
            value: `All`,
            label: `All`
        }, ...flyerClassesData]);

    }, [flyerClasses])


    useEffect(() => {
        if (isAccountTier1 && isSm && isShowRightPanel) {
            dispatch(toggleFlyerRightPanel())
        } else if (!isAccountTier1 && isMd && isShowRightPanel) {
            dispatch(toggleFlyerRightPanel())
        }
    }, [isSm, isMd])

    useEffect(() => {
        if (state.activeFlyers.length === 1 && flyerDetailsState.flyRecId !== 0) {
            try {
                // dispatch(clearDataForFlyer());
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_CREAT_NEW_FLYER, false);
                let flyerAppAddress = envManager.flyerAppAddress

                let currentFlyerStatus = flyerDetailsState.flyFstRec;
                let statusCaption = currentFlyerStatus.fstCaption?.toLowerCase()

                let appUrl = '';

                if (statusCaption?.includes('edit')) {
                    appUrl = flyerAppAddress = envManager.getFlyerAppAddressWithEnvPrefix('dev')
                } else if (statusCaption?.includes('qa')) {
                    appUrl = envManager.getFlyerAppAddressWithEnvPrefix('qa')
                } else if (statusCaption?.includes('published')) {
                    appUrl = envManager.getFlyerAppAddressWithEnvPrefix('')
                }

                //
                if (appUrl.length !== 0 && flyerDetailsState.flyRecId) {
                    let accountName = flyerDetailsState.flyAccRec?.accCaption;
                    let flyerName = flyerDetailsState.flyCaption;
                    appUrl += `flyer/${accountName}/${flyerName}`
                }
                // if (appUrl.length !== 0 && state.activeFlyers.flyRecId) {
                //     let accountName = state.activeFlyers.flyAccRec?.accCaption;
                //     let flyerName = state.activeFlyers.flyCaption;
                //     appUrl += `${accountName}/${flyerName}/`
                // }

                if (statusCaption?.includes('inactive')) {
                    appUrl = '--'
                }

                // Any way if the current flyer has no job code (RecId) => no flyer app address to show
                if (!flyerDetailsState.flyRecId) {
                    appUrl = '--'
                }
                // if (!state.activeFlyers.flyRecId) {
                //     appUrl = '--'
                // }
                setState({
                    ...state,
                    url: appUrl
                })

            } catch (e) {
                console.log(e);
            }
        } else {
            if (flyerDetailsState.flyRecId && state.activeFlyers.length === 1) {
                setState({
                    ...state,
                    activeFlyers: [flyerDetailsState],
                    lastActivatedFlyer: flyerDetailsState

                })
            } else {
                setState({
                    ...state,
                    url: "--",
                })
            }
        }
    }, [flyerDetailsState]);

    useEffect(() => {
        const controller = new AbortController();
        if (state.activeFlyers.length === 1 && !infoForPagesTab.isOpen) {
            const activeFlyer = state.activeFlyers.find((flyer: FlyerDto) => flyer);
            if (activeFlyer) {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, activeFlyer.flyCaption);
                const signal = controller.signal;
                dispatch(getFlippingFlyer(activeFlyer.flyRecId!, signal));
            }
        }
        if ((state.activeFlyers.length > 1 || state.activeFlyers.length === 0) && !infoForPagesTab.isOpen) {
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, '');
            setState({
                ...state,
                url: "--",
            })

        }

        return () => {
            controller.abort();
        };
    }, [state.activeFlyers]);


    useEffect(() => {
        // if (userDto) {
        //     const userDtoParse: UserDto = JSON.parse(userDto);
        //     if (userDtoParse.accountTier === 1 || isMobile) {
        //         history.push('/flipbookEditor');
        //     }
        // }
        const data = {
            selectedTabNum: 0,
            pageNo: 0,
        }
        dispatch(setSelectedPageForTabs(data));
        const isFirstTimeCall = localStorage.getItem(`userEnterForFirstTime${userDto?.userId}`) === "true";
        setShowLoader(isFirstTimeCall);
        dispatch(getFlyers(false, false));

        addEventDataTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER, (data: CustomDataEvent) => {
            setOpenPagesTab({
                isOpen: data.data.isOpen,
                flyerCaption: data.data.flyerCaption
            });
        });
        return () => {
            dispatch(clearFlyersData());
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_OPEN_PAGES_FLYER, {
                isOpen: false,
                flyerCaption: ``,
            });
            removeEventTypeListener(EVENT_DATA_TYPE_OPEN_PAGES_FLYER);
            if (activeFlyersRef.current.length) {
                sessionStorage.setItem("activeFlyersArray", `flyer${activeFlyersRef.current[0].flyRecId}`);
            }
        }

    }, []);

    useEffect(() => {
        window.addEventListener('keydown', keydownHandlerFlyersScreen);
        // const scrollPosition = sessionStorage.getItem("activeFlyersArray");
        // const contentDiv = document.getElementById("flyersContentContainer");
        // if (scrollPosition && contentDiv) {
        //     contentDiv.scrollTo(0, parseInt(scrollPosition));
        // }
        activeFlyersRef.current = state.activeFlyers;
        return () => {
            window.removeEventListener('keydown', keydownHandlerFlyersScreen);
        }
    }, [state])

    useEffect(() => {
        if (isXs) {
            setState({
                ...state,
                activeFlyers: [],
                showLoader: false,
                lastActivatedFlyer: {},
            })
        }
    }, [isXs]);


    useEffect(() => {
        if (flyersState.type === ActionType.GET_FLYERS_SUCCESS) {
            const flyersAfterFiltering = getFlyersAfterAllFiltersFromFilters(selectValue.value, 'view');
            if (flyersAfterFiltering.flyersData.length > 0) {
                if (flyerDetailsState.flyCaption !== "") {
                    const activeFlyer = flyersAfterFiltering.flyersData.find((key: FlyerDto) => key.flyRecId === flyerDetailsState.flyRecId);
                    setState({
                        ...state,
                        ...flyersAfterFiltering,
                        activeFlyers: isXs ? [] : activeFlyer ? [activeFlyer] : [flyersAfterFiltering.flyersData[0]],
                        // flyersData: flyersState.flyers,
                        archiveCount: flyersState.archivedFlyersCount!,
                        softDeleteCount: flyersState.softDeletedFlyersCount!,
                        showLoader: false,
                        lastActivatedFlyer: isXs ? {} : activeFlyer ? activeFlyer : flyersAfterFiltering.flyersData[0],
                    })
                    dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, activeFlyer ? activeFlyer.flyCaption : flyersState.flyers[0].flyCaption);
                } else {
                    setState({
                        ...state,
                        ...flyersAfterFiltering,
                        activeFlyers: isXs ? [] : [flyersAfterFiltering.flyersData[0]],
                        // flyersData: flyersState.flyers,
                        archiveCount: flyersState.archivedFlyersCount!,
                        softDeleteCount: flyersState.softDeletedFlyersCount!,
                        showLoader: false,
                        lastActivatedFlyer: isXs ? {} : flyersAfterFiltering.flyersData[0],

                    })

                    dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, flyersState.flyers[0].flyCaption);
                }
            } else {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, '');
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
                setState({
                    ...state,
                    archiveCount: flyersState.archivedFlyersCount!,
                    softDeleteCount: flyersState.softDeletedFlyersCount!,
                    showLoader: false
                })
            }
            removeWelcomeAndLoaderScreen();
        } else if (flyersState.type === ActionType.SOFT_DELETE_FLYER_SUCCESS || flyersState.type === ActionType.ARCHIVE_FLYER_SUCCESS) {
            if (flyersState.type === ActionType.SOFT_DELETE_FLYER_SUCCESS) {
                setState({
                    ...state,
                    softDeleteCount: state.softDeleteCount + (state.activeFlyers.length && actionIds.length === 0 ? state.activeFlyers.length : actionIds.length),
                })

            } else {
                setState({
                    ...state,
                    archiveCount: state.archiveCount + (state.activeFlyers.length && actionIds.length === 0 ? state.activeFlyers.length : actionIds.length),
                })
            }
        } else if (flyersState.type === ActionType.HARD_DELETE_FLYER_SUCCESS) {
            setState({
                ...state,
                showLoader: false
            })
        } else if (flyersState.type === ActionType.SOFT_DELETE_FLYER_ERROR
            || flyersState.type === ActionType.ARCHIVE_FLYER_ERROR
            || flyersState.type === ActionType.GET_FLYERS_ERROR
            || flyersState.type === ActionType.HARD_DELETE_FLYER_ERROR) {
            setState({
                ...state,
                showLoader: false
            })
        } else if (flyersState.type === ActionType.GET_FLYERS_START) {
            setState({
                archiveCount: 0,
                softDeleteCount: 0,
                flyersData: [],
                activeFlyers: [],
                url: '',
                showLoader: flyersState.loading
            })
        } else if (flyersState.type === ActionType.CHANGE_FLYERS_STATE) {
            // if (existedActiveFlyers.length >= 1 && !infoForPagesTab.isOpen) {
            //     dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, '');
            //     dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
            // }
            if (infoForPagesTab.isOpen) {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
                try {
                    const data = {
                        pageNo: 0,
                        selectedTabNum: 1
                    }
                    dispatch(setSelectedPageForTabs(data));
                    dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, infoForPagesTab.flyerCaption);

                } catch (e) {

                }
            }
            const flyersAfterFiltering = getFlyersAfterAllFiltersFromFilters(selectValue.value, 'view');
            const existedActiveFlyers = flyersAfterFiltering.flyersData?.filter((flyer: FlyerDto) => {
                const isActiveFlyerExist = state.activeFlyers?.some((activeFlyer: FlyerDto) => flyer.flyRecId === activeFlyer.flyRecId);
                if (isActiveFlyerExist) {
                    return flyer;
                }
            });
            if (isShowCreateNewFlyerPopup) {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, flyersState.flyers[0].flyCaption);

                setState({
                    ...state,
                    ...flyersAfterFiltering,
                    activeFlyers: isXs ? [] : [flyersAfterFiltering.flyersData[0]],
                    // flyersData: flyersState.flyers,
                    showLoader: false,
                    lastActivatedFlyer: isXs ? {} : flyersAfterFiltering.flyersData[0],
                })
            } else {
                setState({
                    ...state,
                    ...flyersAfterFiltering,
                    activeFlyers: isXs ? [] : existedActiveFlyers.length >= 1 ? existedActiveFlyers : flyersAfterFiltering.activeFlyers.length ? flyersAfterFiltering.activeFlyers : [],
                    // flyersData: flyersState.flyers,
                    showLoader: false,
                    lastActivatedFlyer: isXs ? {} : flyersAfterFiltering.flyersData[0],
                })
            }
            removeWelcomeAndLoaderScreen();
        }

    }, [flyersState]);


    useEffect(() => {
        if (flyerDetails.type === ActionType.GET_FLIPPING_FLYER_COMPLETED && (flyersState.type === ActionType.GET_FLYERS_COMPLETED || ActionType.CHANGE_FLYERS_STATE)) {
            if (flyerDetails.flyerDto?.flyRecId && state.activeFlyers.length === 1) {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
                if(isUserViewer){
                    setDisabledStatus(true);
                } else {
                    setDisabledStatus(false);
                }

                // dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
                // dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, flyerDetails.flyerDto.flyCaption);
            }
        } else if (flyerDetails.type === ActionType.POST_FLIPPING_FLYER_START) {
            setState({
                ...state,
                showLoader: true
            })
            // setShowLoader(true);
        } else if (flyerDetails.type === ActionType.GET_FLIPPING_FLYER_ERROR
            || flyerDetails.type === ActionType.POST_FLIPPING_FLYER_ERROR
            || flyerDetails.type === ActionType.POST_FLYER_PROMOITEMS_ERROR
            || flyerDetails.type === ActionType.POST_FLYER_SPOTS_ERROR) {
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, true);
            setState({
                ...state,
                showLoader: false
            })
        }
    }, [flyerDetails])

    const onAddNewButtonClick = () => {
        if(!isDisabledOptionBeforeFlyerWillBeReady){
            dispatch(toggleFlyerDetailsPopup(true));
        }
    }

    const openFlyerDetails = (rowIndex: number, flyerDto: FlyerDto): void => {
        console.log('rowIndex:' + rowIndex);
        console.log('flyerDto.flyRecId:' + flyerDto.flyRecId);
        history.push(`/flyersCatalog/${flyerDto.flyRecId}`)
    }

    const urlClick = () => {
        window.open(state.url, 'urlFromMainScreen');
    }

    const removeWelcomeAndLoaderScreen = () => {
        const isFirstTimeCall = localStorage.getItem(`userEnterForFirstTime${userDto?.userId}`) === "true";
        if (flyersState.flyers.length === 0 && isFirstTimeCall) {
            setShowLoader(false);
            setShowWelcomeScreen(true);
        } else {
            setShowLoader(false);
            setShowWelcomeScreen(false);
            if (isFirstTimeCall) {
                localStorage.removeItem(`userEnterForFirstTime${userDto?.userId}`);
            }
        }
    }

    const getFlyersAfterAllFiltersFromFilters = (value: string, filterName: "view" | "class"): {
        flyersData: FlyerDto[],
        activeFlyers: FlyerDto[],
        lastActivatedFlyer?: FlyerDto
    } => {
        let flyersData: {
            flyersData: FlyerDto[],
            activeFlyers: FlyerDto[],
            lastActivatedFlyer?: FlyerDto
        };
        // Check if the filter name is "view"
        if(filterName === "view") {
            // If the selected value is not "All"
            if (value !== 'All' && value !== 'Expired') {
                // Filter the flyers based on the selected view value
                const filteredFlyers = flyersState.flyers.filter((key) => {
                    const validUntil = getDate(key.flyValidToUtc);
                    if (key.flyFstRec!.fstCaption === value && validUntil && new Date() < validUntil) {
                        return key;
                    }
                })
                // Check if the selected class value is not "All"
                if (selectClassesValue.value !== "All") {
                    // Filter the filtered flyers based on the selected class value
                    const filteredFlyersFromStatusFilter = filteredFlyers.filter((key: FlyerDto) => {
                        if ((key.flyFlyerClassId === Number(selectClassesValue.value)) || (key.flyFlyerClassId === null && Number(selectClassesValue.value) === -1)) {
                            return key;
                        }
                    });
                    // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                    flyersData = {
                        activeFlyers: filteredFlyersFromStatusFilter.length ? [filteredFlyersFromStatusFilter[0]] : [],
                        flyersData: filteredFlyersFromStatusFilter,
                        lastActivatedFlyer: filteredFlyersFromStatusFilter.length ? filteredFlyersFromStatusFilter[0] : {}
                    }
                } else {
                    // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                    flyersData = {
                        activeFlyers: filteredFlyers.length ? [filteredFlyers[0]] : [],
                        flyersData: filteredFlyers,
                        lastActivatedFlyer: filteredFlyers.length ? filteredFlyers[0] : {}
                    }
                }
            } else {
                if(value === 'Expired'){
                    // Check if the selected class value is not "All"
                    if (selectClassesValue.value !== "All") {
                        // Filter the flyers based on the selected class value
                        const filteredFlyersFromStatusFilter = flyersState.flyers.filter((key: FlyerDto) => {
                            if ((key.flyFlyerClassId === Number(selectClassesValue.value)) || (key.flyFlyerClassId === null && Number(selectClassesValue.value) === -1)) {
                                return key;
                            }
                        })
                        // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                        const expiredFlyers = filteredFlyersFromStatusFilter.filter((flyer: FlyerDto) => {
                            const validUntil = getDate(flyer.flyValidToUtc);
                            if(validUntil && new Date() > validUntil){
                                return flyer;
                            }
                        })
                        flyersData = {
                            activeFlyers: expiredFlyers.length ? [expiredFlyers[0]] : [],
                            flyersData: expiredFlyers,
                            lastActivatedFlyer: expiredFlyers[0]
                        }
                    } else {
                        // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                        const expiredFlyers = flyersState.flyers.filter((flyer: FlyerDto) => {
                            const validUntil = getDate(flyer.flyValidToUtc);
                            if(validUntil && new Date() > validUntil){
                                return flyer;
                            }
                        })
                        flyersData = {
                            activeFlyers: expiredFlyers.length ? [expiredFlyers[0]] : [],
                            flyersData: expiredFlyers,
                            lastActivatedFlyer: expiredFlyers[0]
                        }
                    }

                } else {
                    // Check if the selected class value is not "All"
                    if (selectClassesValue.value !== "All") {
                        // Filter the flyers based on the selected class value
                        const filteredFlyersFromStatusFilter = flyersState.flyers.filter((key: FlyerDto) => {
                            if ((key.flyFlyerClassId === Number(selectClassesValue.value)) || (key.flyFlyerClassId === null && Number(selectClassesValue.value) === -1)) {
                                return key;
                            }
                        })
                        // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                        flyersData = {
                            activeFlyers: filteredFlyersFromStatusFilter.length ? [filteredFlyersFromStatusFilter[0]] : [],
                            flyersData: filteredFlyersFromStatusFilter,
                            lastActivatedFlyer: filteredFlyersFromStatusFilter[0]
                        }
                    } else {
                        // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                        flyersData = {
                            activeFlyers: flyersState.flyers.length ? [flyersState.flyers[0]] : [],
                            flyersData: flyersState.flyers,
                            lastActivatedFlyer: flyersState.flyers[0]
                        }
                    }
                }
            }
        } else {
            // If the selected value is not "All"
            if (value !== 'All') {
                // Filter the flyers based on the selected class value
                const filteredFlyers = flyersState.flyers.filter((key) => {
                    if ((key.flyFlyerClassId === Number(value)) || (key.flyFlyerClassId === null && Number(value) === -1)) {
                        return key;
                    }
                })
                // Check if the selected view value is not "All"
                if (selectValue.value !== "All" && selectValue.value !== "Expired") {
                    // Filter the filtered flyers based on the selected view value
                    const filteredFlyersFromStatusFilter = filteredFlyers.filter((key: FlyerDto) => {
                        const validUntil = getDate(key.flyValidToUtc);
                        if (key.flyFstRec!.fstCaption === selectValue.value && validUntil && new Date() < validUntil) {
                            return key;
                        }
                    });
                    // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                    flyersData = {
                        activeFlyers: filteredFlyersFromStatusFilter.length ? [filteredFlyersFromStatusFilter[0]] : [],
                        flyersData: filteredFlyersFromStatusFilter,
                        lastActivatedFlyer: filteredFlyersFromStatusFilter.length ? filteredFlyersFromStatusFilter[0] : {}
                    }
                } else {
                    // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                    if(selectValue.value === "Expired"){
                        const expiredFlyers = filteredFlyers.filter((flyer: FlyerDto) => {
                            const validUntil = getDate(flyer.flyValidToUtc);
                            if(validUntil && new Date() > validUntil){
                                return flyer;
                            }
                        })
                        flyersData = {
                            activeFlyers: expiredFlyers.length ? [expiredFlyers[0]] : [],
                            flyersData: expiredFlyers,
                            lastActivatedFlyer: expiredFlyers[0]
                        }
                    } else {
                        flyersData = {
                            activeFlyers: filteredFlyers.length ? [filteredFlyers[0]] : [],
                            flyersData: filteredFlyers,
                            lastActivatedFlyer: filteredFlyers.length ? filteredFlyers[0] : {}
                        }
                    }
                }
            } else {
                // Check if the selected view value is not "All"
                if (selectValue.value !== "All" && selectValue.value !== "Expired") {
                    // Filter the filtered flyers based on the selected view value
                    const filteredFlyersFromStatusFilter = flyersState.flyers.filter((key: FlyerDto) => {
                        const validUntil = getDate(key.flyValidToUtc);
                        if (key.flyFstRec!.fstCaption === selectValue.value && validUntil && new Date() < validUntil) {
                            return key;
                        }
                    })
                    // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                    flyersData = {
                        activeFlyers: filteredFlyersFromStatusFilter.length ? [filteredFlyersFromStatusFilter[0]] : [],
                        flyersData: filteredFlyersFromStatusFilter,
                        lastActivatedFlyer: filteredFlyersFromStatusFilter[0]
                    }
                } else {
                    if(selectValue.value === "Expired"){
                        const expiredFlyers = flyersState.flyers.filter((flyer: FlyerDto) => {
                            const validUntil = getDate(flyer.flyValidToUtc);
                            if(validUntil && new Date() > validUntil){
                                return flyer;
                            }
                        })
                        flyersData = {
                            activeFlyers: expiredFlyers.length ? [expiredFlyers[0]] : [],
                            flyersData: expiredFlyers,
                            lastActivatedFlyer: expiredFlyers[0]
                        }
                    } else {
                        // Set the filtered flyers as the flyersData and set the first flyer in the array as the active and last activated flyer
                        flyersData = {
                            activeFlyers: flyersState.flyers.length ? [flyersState.flyers[0]] : [],
                            flyersData: flyersState.flyers,
                            lastActivatedFlyer: flyersState.flyers[0]
                        }
                    }

                }
            }
        }
        return flyersData;
    }

    const onChangeView = (selectedOption: OptionTypeBase) => {
        const value = selectedOption.value;
        setSelectValue(selectedOption);
        dispatch(changeFlyersViewFilter(selectedOption));
        const newStateForFlyers = getFlyersAfterAllFiltersFromFilters(value, "view");
        setState({
            ...state,
            ...newStateForFlyers
        });

    }

    const onChangeClassesView = (selectedOption: OptionTypeBase) => {
        const value = selectedOption.value;
        setSelectClassesValue(selectedOption);
        dispatch(changeFlyersClassFilter(selectedOption));

        const newStateForFlyers = getFlyersAfterAllFiltersFromFilters(value, "class");
        setState({
            ...state,
            ...newStateForFlyers
        });

    }

    const onSoftDeleteFlyer = (ids: number[]) => {
        setState({
            ...state,
            showLoader: true
        })
        // setShowLoader(true);
        const activeFlyersIds = state.activeFlyers.map((activeFlyer: FlyerDto) => activeFlyer.flyRecId!);
        dispatch(softDeleteFlyer(ids.length ? ids : activeFlyersIds, 'en-Us', true, flyersState));
    }

    const onHardDeleteFlyer = () => {
        setShowModal(false);
        setState({
            ...state,
            showLoader: true
        })
        // setShowLoader(true);
        const activeFlyersIds = state.activeFlyers.map((activeFlyer: FlyerDto) => activeFlyer.flyRecId!);
        dispatch(hardDeleteFlyer(actionIds.length ? actionIds : activeFlyersIds, flyersState));
    }

    const onArchiveFlyer = (ids: number[]) => {
        setState({
            ...state,
            showLoader: true
        })
        // setShowLoader(true);
        const activeFlyersIds = state.activeFlyers.map((activeFlyer: FlyerDto) => activeFlyer.flyRecId!);
        dispatch(archiveFlyer(ids.length ? ids : activeFlyersIds, 'en-Us', true, flyersState));
    }

    const doubleClickOnFlayer = (flyerDto: FlyerDto) => {
        // if(flyerDetails.type === ActionType.GET_FLIPPING_FLYER_COMPLETED){
        try {
            const data = {
                selectedTabNum: 1,
                pageNo: 0
            }
            dispatch(setSelectedPageForTabs(data));

            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, flyerDto.flyCaption);
            dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
            hideMenu();
            if (!isShowCreateNewFlyerPopup && flyerDto) {
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
                dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, flyerDto.flyCaption);
                dispatch(getFlippingFlyer(flyerDto.flyRecId!));
            }
            setDisabledStatus(true);

        } catch (e) {

        }
        // }
    }

    const keydownHandlerFlyersScreen = (e: any) => {
        const target = e.target as HTMLElement;
        if (e.code === 'KeyA' && e.ctrlKey && target.nodeName !== "INPUT") {
            e.preventDefault();
            if (state.activeFlyers.length === flyersState.flyers.length) {
                setState({
                    ...state,
                    activeFlyers: [],
                    lastActivatedFlyer: flyersState.flyers[0]
                })
            } else {
                setState({
                    ...state,
                    activeFlyers: flyersState.flyers,
                    lastActivatedFlyer: flyersState.flyers[0]
                })
            }
            // dispatch(resetFlyerState());
        }
    }

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: 'confirmHardDeleteFlipbook',
        confirmOnClick: {
            onHardDeleteClick: onHardDeleteFlyer,
        }
    };

    let settingsForPopup = getSettingsForPopup(settings);

    const flyers = state.flyersData.map((key, index) => {
        // if (activeFlyers !== '') {
        const isActivePage = state.activeFlyers.some((activeFlyer: FlyerDto) => activeFlyer.flyCode === key.flyCode)
        // const isActivePage = state.activeFlyer.flyCode === key.flyCode;
        let columnNumbersWidth = 4;
        if (isAccountTier1) {
            if (!isSm) {
                if (isLg && !isMdForContent) {
                    columnNumbersWidth = 6;
                } else if (isMdForContent) {
                    columnNumbersWidth = 12;
                }
            } else {
                if (isXs) {
                    columnNumbersWidth = 12;
                } else if (isLg || isMdForContent || isSm) {
                    columnNumbersWidth = 6;
                }
            }

        } else {
            if (!isMd) {
                if (isLg && !isMdForContent) {
                    columnNumbersWidth = 6;
                } else if (isMdForContent) {
                    columnNumbersWidth = 12;
                }
            } else {
                if (isXs) {
                    columnNumbersWidth = 12;
                } else if (isLg || isMdForContent || isSm) {
                    columnNumbersWidth = 6;
                }
            }

        }

        if (!isShowRightPanel) {
            if (isXs) {
                columnNumbersWidth = 12;
            } else if (isSm) {
                columnNumbersWidth = 6;
            } else if (isMd) {
                columnNumbersWidth = 4;
            } else if (isLg) {
                columnNumbersWidth = 3;
            } else {
                columnNumbersWidth = 2;
            }
        }

        return <Flyer key={key.flyCode} flyerDto={key} isActive={isActivePage}
            // setActiveFlyer={setActiveFlyer}
                      openFlyerDetails={openFlyerDetails} flyerIndex={index + 1}
                      onSoftDeleteFlyer={onSoftDeleteFlyer}
                      onArchiveFlyer={onArchiveFlyer}
                      setActionIds={setActionIds}
                      onAddNewButtonClick={onAddNewButtonClick}
                      doubleClickOnFlyer={doubleClickOnFlayer}
                      flyersState={state}
                      setFlyerState={setState}
                      setDisabledStatus={setDisabledStatus}
                      isDisabledOptionBeforeFlyerWillBeReady={isDisabledOptionBeforeFlyerWillBeReady}
                      lastSelectedFlyer={state.lastActivatedFlyer}
                      setShowModal={setShowModal}
                      columnNumbersWidth={columnNumbersWidth}
                      setIsShouldCheckCurrentFlyerStateBeforeLeave={setIsShouldCheckCurrentFlyerStateBeforeLeave}
                      setFlyersForHold={setFlyersForHold}
        />
        // }
    });

    if (isShowLoader) {
        return (
            <Box
                sx={{
                    position: `absolute`,
                    top: '0',
                    zIndex: 12,
                    left: '0',
                    width: '100%',
                    height: '100%',
                    background: '#ffffff',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <>
            {
                showWelcomeScreen &&
                <WelcomeScreen/>
            }
            {
                (!showWelcomeScreen) &&
                <Box>
                    <div className={styles.container}>
                        <Grid container columns={16} sx={{
                            height: "100%"
                        }}>
                            <Grid item xl={!isShowRightPanel ? 15.8 : isAccountTier1 ? 11 : 10}
                                  lg={!isShowRightPanel ? 15.8 : isAccountTier1 ? 9 : 8} sm={16}
                                  md={isAccountTier1 ? !isShowRightPanel ? 15.8 : 8 : 16} xs={16}
                                  sx={{
                                      flexFlow: "column",
                                      display: "flex",
                                      height: "100%",
                                      position: "relative",
                                      transition: `all ${rightPanelAnimationTimeInMs}ms`,
                                  }}
                            >
                                {
                                    state.showLoader &&
                                    <div className={styles.loading}>
                                        {state.showLoader && <PageSpinner/>}
                                    </div>
                                }
                                <Grid className={classes.headerContainer} container>
                                    <Grid item className={classes.headerItem} xs={!isXs ? 9 : 12}>
                                        <Box className={`${classes.boxes} leftControls`}>
                                            <div onClick={onAddNewButtonClick} className={classes.newFlyerBtnWrapper}>
                                                <OrangeButton buttonName='+ New Flyer'
                                                              isDisabled={isDisabledOptionBeforeFlyerWillBeReady}/>
                                            </div>
                                            {
                                                !isXs &&
                                                <>
                                                    <div>
                                                        View by Status:
                                                    </div>
                                                    <Select
                                                        id={"flyer_status_selector"}
                                                        classNamePrefix='flyer_status_selector'
                                                        value={selectValue}
                                                        onChange={onChangeView}
                                                        getOptionValue={(option) => option.value}
                                                        getOptionLabel={(option) => {
                                                            let numberOfFlyers: number = flyersState.flyers.length;
                                                            if (option.value !== 'All' && option.value !== 'Expired') {
                                                                const filteredFlyer = flyersState.flyers.filter((flyer) => {
                                                                    const validUntil = getDate(flyer.flyValidToUtc);
                                                                    if (flyer.flyFstRec!.fstCaption === option.value && validUntil && new Date() < validUntil) {
                                                                        return flyer;
                                                                    }
                                                                })
                                                                numberOfFlyers = filteredFlyer.length;
                                                            }
                                                            if(option.value === 'Expired'){
                                                                const filteredFlyer = flyersState.flyers.filter((flyer) => {
                                                                    const validUntil = getDate(flyer.flyValidToUtc);
                                                                    if(validUntil && new Date() > validUntil){
                                                                        return flyer;
                                                                    }
                                                                })
                                                                numberOfFlyers = filteredFlyer.length;
                                                            }

                                                            return `${option.label} (${numberOfFlyers})`;
                                                        }}
                                                        isOptionDisabled={(option) => {
                                                            let numberOfFlyers: number = flyersState.flyers.length;
                                                            if (option.value !== 'All' && option.value !== 'Expired') {
                                                                const filteredFlyer = flyersState.flyers.filter((flyer) => {
                                                                    const validUntil = getDate(flyer.flyValidToUtc);
                                                                    if (flyer.flyFstRec!.fstCaption === option.value && validUntil && new Date() < validUntil) {
                                                                        return flyer;
                                                                    }
                                                                })
                                                                numberOfFlyers = filteredFlyer.length;
                                                            }
                                                            if(option.value === 'Expired'){
                                                                const filteredFlyer = flyersState.flyers.filter((flyer) => {
                                                                    const validUntil = getDate(flyer.flyValidToUtc);
                                                                    if(validUntil && new Date() > validUntil){
                                                                        return flyer;
                                                                    }
                                                                })
                                                                numberOfFlyers = filteredFlyer.length;
                                                            }
                                                            return numberOfFlyers === 0;
                                                        }}

                                                        options={selectedOptions}
                                                        styles={customStyles}
                                                        isSearchable={false}
                                                    />
                                                    <div>
                                                        By Flyer Class:
                                                    </div>
                                                    <Select
                                                        id={"flyer_classes_selector"}
                                                        classNamePrefix='flyer_classes_selector'
                                                        value={selectClassesValue}
                                                        onChange={onChangeClassesView}
                                                        getOptionValue={(option) => option.value}
                                                        isOptionDisabled={(option) => {
                                                            let numberOfFlyers: number = flyersState.flyers.length;
                                                            if (option.value !== 'All') {
                                                                const filteredFlyer = flyersState.flyers.filter((flyer) => {
                                                                    if ((flyer.flyFlyerClassId === Number(option.value)) || (flyer.flyFlyerClassId === null && Number(option.value) === -1)) {
                                                                        return flyer;
                                                                    }
                                                                })
                                                                numberOfFlyers = filteredFlyer.length;
                                                            }
                                                            return numberOfFlyers === 0;
                                                        }}
                                                        getOptionLabel={(option) => {
                                                            let numberOfFlyers: number = flyersState.flyers.length;
                                                            if (option.value !== 'All') {
                                                                const filteredFlyer = flyersState.flyers.filter((flyer) => {
                                                                    if ((flyer.flyFlyerClassId === Number(option.value)) || (flyer.flyFlyerClassId === null && Number(option.value) === -1)) {
                                                                        return flyer;
                                                                    }
                                                                })
                                                                numberOfFlyers = filteredFlyer.length;
                                                            }

                                                            return `${option.label} (${numberOfFlyers})`;
                                                        }}
                                                        options={flyerClassesState}
                                                        styles={customStylesClassesView}
                                                        isSearchable={false}
                                                    />
                                                </>
                                            }
                                        </Box>
                                    </Grid>
                                    {/*
                                <Grid item className={classes.headerItem} xs={5.5}>
                                    <Box className={classes.boxes}>
                                        <div>
                                            URL:
                                        </div>
                                        <div className={classes.urlBox} onClick={urlClick}>
                                            {state.url}
                                        </div>
                                    </Box>
                                </Grid>
*/}
                                    {
                                        !isXs &&
                                        <Grid item className={classes.headerItem} xs>
                                            <Box className={`${classes.boxes} rightControls`}>
                                                <Button
                                                    title={`Archived Flyer`}
                                                    className={classes.buttonLeftSide}
                                                    onClick={() => {
                                                        dispatch(resetFlyerState());
                                                        dispatch(getFlyers(true, false));
                                                        history.push('/flyersCatalog/archive');
                                                    }}>
                                                    <ArchiveIcon/>
                                                    <div className={classes.counterWrapper}>
                                                        {state.archiveCount}
                                                    </div>
                                                </Button>
                                                <Button
                                                    title={`Deleted Flyer`}
                                                    className={classes.buttonLeftSide}
                                                    onClick={() => {
                                                        dispatch(resetFlyerState());
                                                        dispatch(getFlyers(false, true));
                                                        history.push('/flyersCatalog/trash');
                                                    }}>
                                                    <DeleteIcon/>
                                                    <div className={classes.counterWrapper}>
                                                        {state.softDeleteCount}
                                                    </div>
                                                </Button>
                                            </Box>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid container className={classes.contentWrapper} id={"flyersContentContainer"}
                                      columnSpacing={"12px"}
                                      rowSpacing={"12px"}
                                    // onScroll={onScrollContent}
                                >
                                    {flyers}
                                </Grid>
                            </Grid>
                            {
                                !isMd && !isAccountTier1 &&
                                <Grid item xs
                                      sx={{
                                          flexFlow: "column",
                                          display: "flex",
                                          height: "100%",
                                          overflow: "hidden",
                                      }}
                                >
                                    <FlyerDetailsRightPanel
                                        setCurrentState={setState}
                                        currentState={state}
                                        activeFlyers={state.activeFlyers}
                                        isShouldCheckCurrentFlyerStateBeforeLeave={isShouldCheckCurrentFlyerStateBeforeLeave}
                                        setIsShouldCheckCurrentFlyerStateBeforeLeave={setIsShouldCheckCurrentFlyerStateBeforeLeave}
                                        flyersForHold={flyersForHold}
                                        rightPanelAnimationTimeInMs={rightPanelAnimationTimeInMs}
                                    />
                                </Grid>
                            }

                            {
                                !isSm && isAccountTier1 &&
                                <Grid item xs
                                      sx={{
                                          flexFlow: "column",
                                          display: "flex",
                                          height: "100%",
                                          overflow: "hidden"
                                      }}
                                >
                                    <Box
                                        sx={{
                                            background: "#FFFFFF",
                                            zIndex: "4",
                                            letterSpacing: "0.2px",
                                            display: "flex",
                                            flexFlow: "column",
                                            height: "100%",
                                            borderLeft: "1px solid #888888",
                                        }}
                                    >
                                        <FlippingFlyersCatalogCreateEditFlyer isSm={isSm}
                                                                              activeFlyers={state.activeFlyers}
                                                                              rightPanelAnimationTimeInMs={rightPanelAnimationTimeInMs}

                                        />
                                    </Box>
                                </Grid>
                            }

                        </Grid>
                    </div>
                </Box>
            }
            {isShowModal &&
                <StatusPopup
                    settings={settingsForPopup}
                    type={StatusPopupType.INFO}
                    title={'INFO'}
                    subTitle={''}
                    messages={[settingsForPopup.messages]}
                    show={isShowModal}
                    handleClose={() => setShowModal(false)}
                />
            }
        </>
    )
}